<template>
  <div>
    <KeyTableView
      v-if="shouldShowLegacyTable"
      :keyType="$options.legacy"
      :webAuthnKeys="legacyCredentials"
    />
    <KeyTableView
      :keyType="$options.securityKey"
      :webAuthnKeys="securityKeyCredentials"
    >
      <template v-slot:addButton>
        <IconButton
          :data-test-id="$testId('addButton')"
          icon="add"
          text="Add Key"
          type="primary"
          @click="addKey"
        />
      </template>
    </KeyTableView>
    <KeyTableView
      :keyType="$options.deviceBiometric"
      :webAuthnKeys="deviceBiometricCredentials"
    >
      <template v-slot:emptyState>
        <ParagraphBody>
          Users can enroll from the User Portal.
        </ParagraphBody>
      </template>
    </KeyTableView>
  </div>
</template>

<script>
import { IconButton, ParagraphBody } from '@jumpcloud/ui-components';
import { keyTypes } from 'client/systemusers/UserDetails/WebAuthnKeys/webAuthnHelpers';
import { mapGetters } from 'vuex';
import KeyTableView from 'client/systemusers/UserDetails/WebAuthnKeys/KeyTableView.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';
import RegisterWebAuthnKeyModal from 'client/systemusers/UserDetails/RegisterWebAuthnKeyModal.vue';

const {
  deviceBiometric, securityKey, legacy,
} = keyTypes;

export default {
  name: 'WebAuthnKeys',

  components: {
    IconButton,
    KeyTableView,
    ParagraphBody,
  },

  deviceBiometric,
  securityKey,
  legacy,

  computed: {
    ...mapGetters('SystemUserWebAuthnKeysModel', [
      'legacyCredentials',
      'securityKeyCredentials',
      'deviceBiometricCredentials',
    ]),

    shouldShowLegacyTable() {
      return !!this.legacyCredentials.length;
    },
  },

  methods: {
    addKey() {
      ModalEventBus.open({
        component: RegisterWebAuthnKeyModal,
      });
    },
  },
};
</script>
